import { useQuery } from "react-query";
import { viewWeddingInvites } from "../actions/wedding";

export const useGuestList = () => {
	return useQuery("guest", viewWeddingInvites, {
		refetchOnWindowFocus: false,
		// refetchOnmount: true,
	});
};
